import React, { useCallback, useEffect, useState } from "react";
import { Box, Button, InputLabel, Stack, TextField, Switch, Autocomplete, Typography } from "@mui/material";
import { DatePicker, TimePicker } from "@mui/x-date-pickers";
import { Event } from "../../Models/Event.ts";
import dayjs from "dayjs";
import { addOrUpdateEvent } from "../../Requests/EventService.ts";
import ImageDropzone from "../StyledComponents/AvatarDropzone/ImageDropzone.tsx";
import { getSpeakers } from "../../Requests/SpeakerService.ts";
import GooglePlacesAutocomplete, { geocodeByAddress } from "react-google-places-autocomplete";
import { googleAPIKey } from "../../Constants";
import { getEventCategories } from "../../Requests/EventCategoriesService.ts";
import { getGuests } from "../../Requests/GuestService.ts";
import { EVENT_REGISTRATION_STATUS_CASES, EVENT_REGISTRATION_STATUS } from "../../Models/StateConstants.ts";
import HtmlEditor from "../HtmlEditorView/HtmlEditor.jsx";


export default function AddEvent(props) {

  const [image, setImage] = useState()
  const [title, setTitle] = useState("")
  const [venue, setVenue] = useState("")
  const [speakers, setSpeakers] = useState([])
  const [capacity, setCapacity] = useState("")
  const [startDate, setStartDate] = useState()
  const [endDate, setEndDate] = useState()
  const [startTime, setStartTime] = useState()
  const [endTime, setEndTime] = useState()
  const [about, setAbout] = useState("")
  const [street, setStreet] = useState("")
  const [city, setCity] = useState("")
  const [postalCode, setPostalCode] = useState("")
  const [hidden, setHidden] = useState(true)
  const [isNew, setIsNew] = useState(true)
  const [location, setLocation] = useState({ latitude: 0, longitude: 0 })
  const [eventCategories, setEventCategories] = useState([])
  const [guests, setGuests] = useState([])
  const [registrationStatus, setRegistrationStatus] = useState("")
  const [registrationOpenDate, setRegistrationOpenDate] = useState()
  const [registrationOpenTime, setRegistrationOpenTime] = useState()
  const [newEventsOrder, setNewEventsOrder] = useState()

  const [allSpeakers, setAllspeakers] = useState([])
  const [allCategories, setAllCategories] = useState([])
  const [allGuests, setAllGuests] = useState([])

  function convertToDate(date, time) {
    const t = dayjs(time)
    return dayjs(date).hour(t.hour()).minute(t.minute()).toDate()
  }

  const fetchData = useCallback(async () => {
    const speakers = await getSpeakers()
    setAllspeakers(speakers)
    const categories = await getEventCategories()
    setAllCategories(categories.map((category) => category.name))
    const guests = await getGuests()
    setAllGuests(guests)
  }, [])

  const handlePublish = async () => {
    let object = new Event()
    object.title = title
    object.venue = venue
    object.speakers = speakers
    object.capacity = capacity
    object.startDate = convertToDate(startDate, startTime)
    object.endDate = convertToDate(endDate, endTime)
    object.about = about
    object.street = street
    object.city = city
    object.postalCode = postalCode
    object.hidden = hidden
    object.isNew = isNew
    object.location = location
    object.eventCategories = eventCategories
    object.guests = guests
    object.registrationStatus = registrationStatus
    object.registrationStartDate = convertToDate(registrationOpenDate, registrationOpenTime)
    object.newEventsOrder = newEventsOrder
    await addOrUpdateEvent(object, image)
    props.publish()
  }

  const googleAddressChange = async (event) => {
    geocodeByAddress(event.label)
      .then(place => {
        let lat = place[0].geometry.location.lat()
        let lng = place[0].geometry.location.lng()
        setLocation({ latitude: lat, longitude: lng })

        for (var i = 0; i < place[0].address_components.length; i++) {
          var addressType = place[0].address_components[i].types[0]
          switch (addressType) {
            case 'postal_town':
              setCity(place[0].address_components[i].short_name)
              break
            case 'route':
              setStreet(place[0].address_components[i].short_name)
              break
            case 'postal_code':
              setPostalCode(place[0].address_components[i].short_name)
              break
            default:
              break
          }
        }
      })
  }

  useEffect(() => {
    fetchData()
  }, [fetchData])

  return (
    <Box sx={{ p: 3 }}>
      <Box>
        <Stack
          spacing={1}
          marginTop={4}
        >
          <InputLabel>{"Event Category"}</InputLabel>
          <Autocomplete
            multiple
            options={allCategories}
            getOptionLabel={(value) => value}
            filterSelectedOptions
            onChange={(event, value) => setEventCategories(value)}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Select Category"
              />
            )}
          />
        </Stack>

        <ImageDropzone
          title={"Event Image"}
          callbackFile={(file) => { setImage(file) }}
        />

        <Stack
          spacing={1}
          marginTop={4}
        >
          <InputLabel>{"Title"}</InputLabel>
          <TextField
            placeholder="Title"
            value={title}
            onChange={(event) => setTitle(event.target.value)}
          />
        </Stack>

        <Stack
          spacing={1}
          marginTop={4}
        >
          <InputLabel>{"Venue"}</InputLabel>
          <TextField
            placeholder="Venue"
            value={venue}
            onChange={(event) => setVenue(event.target.value)}
          />
        </Stack>

        <Stack
          spacing={1}
          marginTop={4}
        >
          <InputLabel>{"Speakers"}</InputLabel>
          <Autocomplete
            multiple
            options={allSpeakers}
            getOptionLabel={(option) => option.firstName + " " + option.lastName}
            filterSelectedOptions
            onChange={(event, value) => setSpeakers(value)}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Select Speakers"
              />
            )}
          />
        </Stack>

        <Stack
          spacing={1}
          marginTop={4}
        >
          <InputLabel>{"Guests"}</InputLabel>
          <Autocomplete
            multiple
            options={allGuests}
            getOptionLabel={(option) => option.firstName + " " + option.lastName}
            filterSelectedOptions
            onChange={(event, value) => setGuests(value)}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Select Guests"
              />
            )}
          />
        </Stack>

        <Box
          sx={{
            display: "flex",
            gap: 1
          }}
        >
          <Stack
            spacing={1}
            marginTop={4}
          >
            <InputLabel>{"Start Date"}</InputLabel>
            <DatePicker
              format="DD/MM/YYYY"
              onChange={(newValue) => setStartDate(newValue)}
            />
          </Stack>

          <Stack
            spacing={1}
            marginTop={4}
          >
            <InputLabel>{"End Date"}</InputLabel>
            <DatePicker
              format="DD/MM/YYYY"
              onChange={(newValue) => setEndDate(newValue)}
            />
          </Stack>
        </Box>

        <Box
          sx={{
            display: "flex",
            gap: 1
          }}
        >
          <Stack
            spacing={1}
            marginTop={4}
          >
            <InputLabel>{"Start Time"}</InputLabel>
            <TimePicker
              ampm={false}
              onChange={(newValue) => setStartTime(newValue)}
            />
          </Stack>

          <Stack
            spacing={1}
            marginTop={4}
          >
            <InputLabel>{"End Time"}</InputLabel>
            <TimePicker
              ampm={false}
              onChange={(newValue) => setEndTime(newValue)}
            />
          </Stack>
        </Box>

        <Stack
          spacing={1}
          marginTop={4}
        >
          <InputLabel>{"About"}</InputLabel>
          <HtmlEditor
            initialValue={about}
            onChange={value => setAbout(value)} />
        </Stack>

        <Stack
          spacing={1}
          marginTop={8}
        >
          <InputLabel>{"Search Address"}</InputLabel>
          <GooglePlacesAutocomplete
            apiKey={googleAPIKey}
            selectProps={{
              onChange: googleAddressChange,
            }}
          />
        </Stack>

        <Stack
          spacing={1}
          marginTop={4}
        >
          <InputLabel>{"Street"}</InputLabel>
          <TextField
            placeholder="Street"
            value={street}
            onChange={(event) => setStreet(event.target.value)}
          />
        </Stack>

        <Stack
          spacing={1}
          marginTop={4}
        >
          <InputLabel>{"City"}</InputLabel>
          <TextField
            placeholder="City"
            value={city}
            onChange={(event) => setCity(event.target.value)}
          />
        </Stack>

        <Stack
          spacing={1}
          marginTop={4}
        >
          <InputLabel>{"Postal Code"}</InputLabel>
          <TextField
            placeholder="Postal Code"
            value={postalCode}
            onChange={(event) => setPostalCode(event.target.value)}
          />
        </Stack>

        <Stack
          marginTop={4}
        >
          <InputLabel>{"Hidden"}</InputLabel>
          <Switch
            checked={hidden}
            onChange={(event) => setHidden(event.target.checked)}
          />
        </Stack>

        <Stack
          marginTop={4}
        >
          <InputLabel>{"Display in what's new"}</InputLabel>
          <Switch
            checked={isNew}
            onChange={(event) => setIsNew(event.target.checked)}
          />
        </Stack>

        <Stack
          spacing={1}
          marginTop={4}
        >
          <InputLabel>{"Sort order"}</InputLabel>
          <TextField
            type="number"
            placeholder="Enter event position"
            value={newEventsOrder}
            onChange={(event) => setNewEventsOrder(Number(event.target.value))}
          />
        </Stack>

        <Stack
          spacing={1}
          marginTop={4}
        >
          <Typography
            variant="h6"
          >
            Registrations
          </Typography>
        </Stack>

        <Stack
          spacing={1}
          marginTop={4}
        >
          <InputLabel>{"Registration Status"}</InputLabel>
          <Autocomplete
            options={EVENT_REGISTRATION_STATUS_CASES}
            renderInput={(params) => <TextField {...params} />}
            onChange={(event) => setRegistrationStatus(event.target.textContent)}
          />
        </Stack>

        <Box
          hidden={registrationStatus !== EVENT_REGISTRATION_STATUS.SCHEDULED}
        >
          <Stack
            spacing={1}
            marginTop={4}
            direction={"row"}
          >
            <Stack
              spacing={1}
              marginTop={4}
            >
              <InputLabel>{"Registration Open Date"}</InputLabel>
              <DatePicker
                format="DD/MM/YYYY"
                onChange={(newValue) => setRegistrationOpenDate(newValue)}
              />
            </Stack>

            <Stack
              spacing={1}
              marginTop={4}
            >
              <InputLabel>{"Registration Open Time"}</InputLabel>
              <TimePicker
                ampm={false}
                onChange={(newValue) => setRegistrationOpenTime(newValue)}
              />
            </Stack>
          </Stack>
        </Box>

        <Stack
          spacing={1}
          marginTop={4}
        >
          <InputLabel>{"Capacity"}</InputLabel>
          <TextField
            placeholder="Capacity"
            value={capacity}
            onChange={(event) => setCapacity(event.target.value)}
          />
        </Stack>
      </Box>

      <Box
        display="flex"
        justifyContent="right"
        marginTop={4}
      >
        <Button
          variant="contained"
          size="large"
          onClick={() => handlePublish()}
        >
          {"Publish"}
        </Button>
      </Box>
    </Box>
  )
}
